import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import VehicleDetails from './components/VehicleDetails';
import PndApi from '../../../../utils/pnd/PndRestApi';
import VehicleModal from '../AddOrUpdate/components/VehicleModal';
import VehicleHubAssingModal from '../HubAssignment/VehicleHubAssingModal';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import PageHeader from 'src/shared/components/layout/PageHeader';

const VehicleDetailsIndex = () => {
  useEffect(() => {
    getAllVehicleDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [viewHubAssignPopup, setHubAssignPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const getAllVehicleDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllVehicleDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const add = () => {
    setTempData(null);
    setViewDetailPopup(true);
    setTitle("Add Vehicle");
  };

  const edit = async (event) => {
    if (event.vehicleId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Vehicle Details");
    }
  };

  const assignHub = () => {
    setHubAssignPopup(true);
    setTitle("Assign Vehicle to Hub");
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<DirectionsCarIcon fontSize="large" />}
          title="Vehicle Management"
          subtitle="View and manage fleet vehicles, plate numbers, and hub allocations."
          gradient="linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && (
            <VehicleDetails
              reactTableData={reactTableData}
              onAdd={add}
              onEdit={edit}
              onAssignHub={assignHub}
              isNoRecordFound={isNoRecordFound}
            />
          )}
          {isNoRecordFound && (
            <VehicleDetails
              isNoRecordFound={isNoRecordFound}
              onAdd={add}
              onEdit={edit}
              onAssignHub={assignHub}
            />
          )}
          {isNoRecordFound && <SnackbarContent message={"No Record Found"} />}
        </Box>

        {viewDetailPopup &&
          <VehicleModal
            modalShow={viewDetailPopup}
            setModalShow={setViewDetailPopup}
            vehicleData={temp}
            isTitle={isTitle}
          />}

        {viewHubAssignPopup &&
          <VehicleHubAssingModal
            modalShow={viewHubAssignPopup}
            setModalShow={setHubAssignPopup}
            isTitle={isTitle}
            reactTableData={reactTableData}
          />}
      </Container>
    </Box>
  );
};

export default VehicleDetailsIndex;